import React, { useContext } from "react"

import Header from "./Common/Shelters/Header"
import Footer from "./Common/Footer"
import { PCViewContext } from "./Common/PCViewContext"

import Title from "./Detail/Title"
import Lamp from "./Detail/Lamp"
import Information from "./Detail/Information"

import * as styles from "./Common/Styles/DetailContainer.module.scss"
import classNames from "classnames/bind"
const cn = classNames.bind(styles)
import { Shelter, ShelterArea } from "./types/shelter"

const Shelter: React.FC<{
  area: ShelterArea
  shelter: Shelter
}> = ({ area, shelter }) => {
  const isPC = useContext(PCViewContext)

  return (
    <React.Fragment>
      <Header logo={area.logo} />
      <div className={cn("container", isPC ? "pc" : "sp")}>
        <div className={styles.contents}>
          <Title place={shelter.place} />
          <hr className={styles.hr} />
          <Lamp lamp={shelter.crowdStatus} place={shelter.place} />
          <hr className={styles.hr} />
          <Information place={shelter.place} />
        </div>
      </div>
      <Footer />
    </React.Fragment>
  )
}
export default Shelter
